<template>
  <div id="train" class="exam">
    <div class="left">
      <div class="exam-con">
        <div class="content">
          <template v-for="(l, key) in paperQuestion">
            <div class="type">
              <div class="title">
                <p>{{ getNum(key) }}、{{ l.title }}（共{{ l.questionRecordFullList.length }}题，每题{{ l.eachScore }}分）</p>
              </div>
              <div class="list" v-for="(q, index) in l.questionRecordFullList">
                <template v-if="q.answerRecord">
                  <!--填空题 题干-->
                  <template v-if="q.answerRecord.questionType == 'BlankFilling'">
                    <p :id="savelist[key][index].num">{{ savelist[key][index].num }}、
                      <template v-for="(s, k) in q.answerRecord.question.questionStem">
                        <span v-html="replaceNToBr(s)"></span>
                        <el-input v-model="savelist[key][index].tjkAnswerString[k]"
                          v-show="k != q.answerRecord.question.questionStem.length - 1" placeholder="请输入答案"></el-input>
                      </template>
                    </p>
                  </template>
                  <!--选择填空题 题干-->
                  <template v-else-if="q.answerRecord.questionType == 'BlankChoice'">
                    <p :id="savelist[key][index].num">{{ savelist[key][index].num }}、
                      <template v-for="(s, k) in q.answerRecord.question.questionStem">
                        <span v-html="replaceNToBr(s)"></span>
                        <input type="text" class="answer-input" size="1" maxlength="1" placeholder="请输入答案"
                          v-show="k != q.answerRecord.question.questionStem.length - 1"
                          v-model="savelist[key][index].tjkAnswerString[k]" />
                      </template>
                    </p>
                  </template>
                  <!--其余题型 题干-->
                  <template v-else>
                    <p :id="savelist[key][index].num">{{ savelist[key][index].num }}、<span
                        v-html="replaceNToBr(q.answerRecord.question.questionStemString)"></span></p>
                  </template>
                  <!--图片-->
                  <p v-if="q.answerRecord.question.imageUrlList">
                    <template v-for="i in q.answerRecord.question.imageUrlList">
                      <img class="s-img" :src="i" v-if="i != ''" @click="clickImg($event)" />
                    </template>
                  </p>
                  <!--单选题 选项-->
                  <template v-if="q.answerRecord.questionType == 'SingleChoice'">
                    <div class="answer">
                      <p v-for="(value, k) in q.answerRecord.question.choices"><el-radio
                          v-model="savelist[key][index].tjkAnswerString" :label="k">{{ k }}、{{ value }}</el-radio></p>
                    </div>
                  </template>
                  <!--多选题 选项-->
                  <template v-else-if="q.answerRecord.questionType == 'MultipleChoice'">
                    <div class="answer">
                      <el-checkbox-group v-model="savelist[key][index].tjkAnswerString">
                        <p v-for="(value, k) in q.answerRecord.question.choices">
                          <el-checkbox :label="k">{{ k }}、{{ value }}</el-checkbox>
                        </p>
                      </el-checkbox-group>
                    </div>
                  </template>
                  <!--判断题 选项-->
                  <template v-else-if="q.answerRecord.questionType == 'TrueOrFalse'">
                    <div class="answer">
                      <el-radio-group v-model="savelist[key][index].tjkAnswerString">
                        <p><el-radio :label="true">正确</el-radio></p>
                        <p><el-radio :label="false">错误</el-radio></p>
                      </el-radio-group>
                    </div>
                  </template>
                  <!--选择填空题 选项-->
                  <template v-else-if="q.answerRecord.questionType == 'BlankChoice'">
                    <div class="answer">
                      <p v-for="(value, k) in q.answerRecord.question.choices">
                        <span>{{ k }}、{{ value }}</span>
                      </p>
                    </div>
                  </template>
                  <!--简答题 答案-->
                  <template v-else-if="q.answerRecord.questionType == 'ShortAnswer'">
                    <div class="answer">
                      <p>答案：<textarea class="answer-input shortanswer"
                          v-model="savelist[key][index].tjkAnswerString"></textarea></p>
                    </div>
                  </template>
                </template>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div class="right">
      <div class="count">
        <h2>统计</h2>
        <div class="useTime">
          <p>距自动交卷时间</p>
          <span class="blue">{{ time }}</span>
        </div>
        <div class="useTime">
          <p class="txt">满分100分，{{ passScore }}分及格</p>
        </div>
        <ul>
          <li v-for="s in list" :class="{ active3: getClass(s.tjkAnswerString) }"><a :href="'#' + s.num">{{ s.num }}</a>
          </li>
        </ul>
        <div class="btn">
          <div class="hold" @click="exitExam">返回学习</div>
          <div class="submit" @click="saveExam">提交试卷</div>
        </div>
      </div>
    </div>
    <el-dialog title="" :visible.sync="completeDialogVisible" width="360px" :close-on-click-modal='false' center>
      <div class="correct_img" v-show="state == 'passed'"><img src="../../assets/images/correct.png" alt=""></div>
      <div class="correct_img" v-show="state == 'failed'"><img src="../../assets/images/icon_yiahan.png" alt=""></div>
      <div class="score" v-show="state == 'passed'">{{ score }}分</div>
      <div class="state_text1" v-if="state == 'passed'">恭喜你！</div>
      <div class="state_text1" v-if="state == 'failed'">很遗憾！</div>
      <div class="state_text1_1" v-if="state == 'failed'">你未通过测试检验</div>
      <div class="state_text2 newtext"
        v-if="state == 'passed' && knowledgestate == 'jumpToCourse' && (Graduation == 'false' || Graduation == '') && tabstate == null">你已通过“
        <span class="spanclass">{{ knowledgename }}</span>
        ”<br>接下来，请进行下一个课程的<span v-if="Coursestate == 'Study'">学习</span>
        <span v-if="Coursestate == 'Practice'">练习</span>
        <span v-if="Coursestate == 'Exam'">测试</span>
      </div>

      <div class="state_text2 newtext" v-if="state == 'passed' && tabstate == 'noNextTab' && trainFlag == 'theory'">你已通过“<span
          class="spanclass">理论考试</span>”</div>
      <div class="state_text2 newtext" v-if="state == 'passed' && tabstate == 'noNextTab' && trainFlag != 'theory'">你已通过“<span
          class="spanclass">{{ categoryName }}</span>”</div>
      <div class="state_text2 newtext" v-if="state == 'passed' && knowledgestate == 'jumpToKnowledge' && Graduation == 'true'">
        你已通过“<span>{{ Coursename }}</span>”</div>
      <div class="state_text2 newtext" v-if="state == 'passed' && tabstate == 0 && Graduation == 'true'">
        你已通过语音{{ categoryName }}全部课程的学习<br>并获得“{{ huizhang }}”徽章<br>现在可以领取语音任务了</div>
      <div class="state_text2 newtext" v-if="state == 'passed' && tabstate == 'noNextTab' && Graduation == 'true'">
        你已通过语音{{ categoryName }}全部课程的学习<br>并获得“{{ huizhang }}”徽章<br>现在可以领取语音任务了</div>
      <div class="state_text2 newtext"
        v-if="state == 'passed' && knowledgestate == 'jumpToCourse' && tabstate == 'noNextTab' && (Graduation == 'false' || Graduation == '') && trainFlag == 'theory'">
        接下来请进行下一个课程的学习</div>
      <div class="state_text2 newtext"
        v-if="state == 'passed' && knowledgestate == 'jumpToCourse' && tabstate == 'noNextTab' && (Graduation == 'false' || Graduation == '') && trainFlag != 'theory'">
        你已通过全部课程的学习<br>现在可以领取任务了</div>
      <div class="state_text2 newtext" v-if="state == 'passed' && knowledgestate == 'jumpToCourse' && tabstate == 'hasNextTab'">你已通过“
        <span class="spanclass">{{ categoryName }}</span>
        ” <br><br>
        {{$route.query.trainFlag == 'fbtTrain' ? '接下来，请完善你的在线经验和意向班次' : '接下来，请进行下一阶段的学习'}}
      </div>

      <div></div>
      <div class="failed" v-if="state == 'failed'">测试分数：<span>{{ score }}</span>分；剩余测试次数：<span>{{ times }}</span>次</div>
      <div></div>
      <span slot="footer" class="dialog-footer">

        <div class="button_box1">
          <div v-if="state == 'passed' && tabstate == 'noNextTab' && trainFlag != 'theory'" type="primary" @click="isreturn">我知道了</div>
          <div v-if="state == 'passed' && tabstate == 'noNextTab' && trainFlag == 'theory'" type="primary" @click="goindex">去报名并参加实操培训
          </div>
          <div class="out_button_3"
            v-if="state == 'passed' && knowledgestate == 'jumpToCourse' && tabstate == null && Coursestate != 'Study'" type="primary"
            @click="determine">去<span v-if="Coursestate == 'Practice'">练习</span><span v-if="Coursestate == 'Exam'">测试</span>
          </div>
          <div class="out_button_3"
            v-if="state == 'passed' && knowledgestate == 'jumpToCourse' && tabstate == null && Coursestate == 'Study'" type="primary"
            @click="determine">继续学习</div>
          <div class="out_button_3" v-if="state == 'passed' && knowledgestate == 'jumpToCourse' && tabstate == 'hasNextTab' && trainFlag == 'theory'"
            type="primary" @click="goindex">去报名并参加{{ nextcategoryName }}</div>
          <div class="out_button_3" v-if="state == 'passed' && knowledgestate == 'jumpToCourse' && trainFlag != 'theory' && trainFlag == 'fbtTrain'"
            type="primary" @click="goUpdateExp">{{fbtBadge || state == 'passed' ? '修改经验' : '去完善'}}</div><!--因为双11 618最后课程是考试课程，tabIndex最靠后，最有做点处理-->
          <div class="out_button_3" v-if="state == 'passed' && knowledgestate == 'jumpToCourse' && tabstate == 'hasNextTab' && trainFlag != 'theory' && trainFlag != 'fbtTrain'"
            type="primary" @click="goindex">我知道了</div>
        </div>
        <div class="button_box" v-if="state == 'failed'">
          <div class="out_button_1" @click="again">继续测试</div>
          <div class="out_button_2" @click="relearn">重新学习</div>
          <div class="out_button_2" @click="goCuotiji" style="margin-left:10px;" v-if="showExamError">错题集</div>
        </div>

      </span>
    </el-dialog>
    <zoom-img v-if="showImg" @clickit="viewImg" :imgSrc="imgSrc"></zoom-img>
  </div>
</template>

<script>
import zoomImg from '../../components/zoomImg.vue'
export default {
  data() {
    return {
      courseId: this.$route.query.courseId, //课程id
      majorId: this.$route.query.majorId, //技能提升-场景-课程id
      assitantType: this.$route.query.assitantType,//场景id
      passScore: null, //通关分数
      paperQuestion: [],
      examRecordId: '',
      endTime: '',
      time: '',
      showImg: false,
      imgSrc: '',
      num: [],
      savelist: [],
      list: [], //保存时的结果集转换的一维数组，用作答题卡
      completeDialogVisible: false, //考完试点提交弹窗（及格）
      showExamError: false, //显示 错题集开关
      score: null,//考试分数
      state: '',//考试是否通过（状态）
      times: null,//剩余考试次数
      Coursename: '',//当前课程名称
      nextobject: {},//储存当前课程接口返回
      nextCoursename: '',//下一个课程名称
      Coursestate: '',//下一个课程的类型（英文）
      Coursestatename: '',//下一个课程的类型（中文）
      categoryName: '',//当前tab名字
      nextcategoryName: '',//下一个tab名字
      tabstate: null,//tab状态
      fbtBadge: null,//fbtBadge是否获得，bool
      nextcourseId: null,//查询下一个知识点id
      timer : null,
      tabIndex: null,//当前所在tab位置
      huizhang: '',//徽章名字
      Graduation: this.$route.query.Graduation,//是不是结业考试
      theory: this.$route.query.theory,//在线理论跳考试
      knowledgestate: null,//弹窗文字类型：：【'jumpToKnowledge'-知识点跳知识点 | 'jumpToCourse'-知识点跳课程】
      knowledgename: '',//当前知识点或课程名称
      dazhiJump: false,//打字认证跳系统实操
      randomNumbers: [],
      trainFlag: this.$route.query.trainFlag,//判断是不是理论跳转考试
      sceneId: this.$route.query.sceneId,
      trainId: this.$route.query.trainId,
      tjkId: this.$route.query.tjkId
    }
  },
  components: {
    'zoom-img': zoomImg
  },
  created() {
  },
  mounted() {
    if (this.assitantType == 'OnlineUpgradeSkill') {
      if (!window.myTaojinWebBrower && !this.$route.query.ht) {
        alert('请在小助手中参加考试！')
        window.location.href = '/tjkStudy/train/index'
        return;
      }
      this.$http.post('http://local.itaojin.cn:26688/api/TjHawkeye/checkRemoteSoftware').then(response => {
        var result = response.data;
        if (!!result.data) {
          alert(`培训过程中,不能开启${result.data}软件,请关闭之后再继续进行考试。`)
          window.location.href = '/tjkStudy/train/index'
        } else {
          this.getExam();
        }
      }, (res) => {
        this.getExam();
      })
    } else {
      this.getExam();
    }
  },
  watch: {
    paperQuestion: function () {
      for (var i = 0; i < this.paperQuestion.length; i++) {
        var xti = [];
        var numlength = parseInt(this.num.length);
        for (var j = 0; j < this.paperQuestion[i].questionRecordFullList.length; j++) {
          this.num.push(j);

          if (this.paperQuestion[i].questionRecordFullList[j].answerRecord.questionType == 'SingleChoice' || this.paperQuestion[i].questionRecordFullList[j].answerRecord.questionType == 'TrueOrFalse' || this.paperQuestion[i].questionRecordFullList[j].answerRecord.questionType == 'ShortAnswer') {
            var temp = {
              'num': numlength + j + 1,
              'examRecordId': this.paperQuestion[i].questionRecordFullList[j].examRecordId,
              'questionRecordId': this.paperQuestion[i].questionRecordFullList[j].questionRecordId,
              'sequence': this.paperQuestion[i].questionRecordFullList[j].sequence,
              'tjkAnswerString': this.paperQuestion[i].questionRecordFullList[j].tjkAnswer != null ? this.paperQuestion[i].questionRecordFullList[j].tjkAnswer : ''
            }
          } else {
            var temp = {
              'num': numlength + j + 1,
              'examRecordId': this.paperQuestion[i].examRecordId,
              'questionRecordId': this.paperQuestion[i].questionRecordFullList[j].questionRecordId,
              'sequence': this.paperQuestion[i].questionRecordFullList[j].sequence,
              'tjkAnswerString': this.paperQuestion[i].questionRecordFullList[j].tjkAnswer != null ? this.paperQuestion[i].questionRecordFullList[j].tjkAnswer : []
            }
          }
          xti.push(temp);
        }
        this.savelist.push(xti);
      }
      this.list = [].concat.apply([], this.savelist);
    }
  },
  methods: {
    //点击我知道了
    isreturn() { this.completeDialogVisible = false, this.$router.back() },
    //报名或参加下一个tab
    goindex() {
      this.$router.replace({ path: '/train/index' })
    },
    //报名或参加下一个tab
    goUpdateExp() {
      this.$router.replace({ path: '/train/fbtExperienceChoose?tabIndex='+ this.$route.query.tabIndex })
    },
    //点击继续（学习，练习，测试）
    determine() {
      if (this.nextobject.next && !this.nextobject.nextCourse && !this.nextobject.nextCategory) {
        this.nextcourseId = this.nextobject.next.courseId
        window.location.href = "/tjkStudy/vedioDetail?courseId=" + this.nextcourseId + '&knowledgeSeq=' + this.nextobject.next.knowledgeSeq + '&CourseLevel=' + this.CourseLevel + '&sceneId=' + this.$route.query.sceneId + '&assitantTjkId=' + this.$route.query.tjkId + '&tjkId=' + this.$route.query.tjkId + '&trainId=' + this.$route.query.trainId + '&knowledgeId=' + this.knowledgeId
      } else if (!this.nextobject.nextCategory && this.nextobject.nextCourse && this.nextobject.next) {
        this.nextcourseId = this.nextobject.nextCourse.courseId
        this.toStudy()
      } else if (!this.nextobject.nextCategory && this.nextobject.nextCourse) {
        this.nextcourseId = this.nextobject.nextCourse.courseId
        this.gotoStudy()
      } else if (this.nextobject.nextCategory) {
        this.$router.replace({ path: '/train/index' })
      } else if (!this.nextobject.next && !this.nextobject.nextCourse && !this.nextobject.nextCourse) {
        this.$router.replace({ path: '/train/index' })
      }
    },
    gotoStudy() {


      this.$http.post(API_ROOT.college + "/course/getKnowledgeListXlk", { courseId: this.nextcourseId })
        .then(
          (res) => {
            var result = res.data;
            if (result.success) {
              if (result.data.knowledgeRecordFullList.length != 1 && result.data.knowledgeRecordFullList.length != 0) {
                this.$router.replace({
                  path: '/train/Secondarylist', query: {
                    courseId: this.nextcourseId

                  }
                })
              } else if (this.CourseLevel == 3) {


                this.$router.replace({
                  path: '/train/SpecialCourses', query: {
                    sceneId: this.$route.query.sceneId,
                    trainId: this.$route.query.trainId,
                    tjkId: this.$route.query.tjkId,
                    assitantTjkId: this.$route.query.tjkId

                  }
                })
              }


              else {
                this.tabIndex = localStorage.getItem('tabIndex')

                this.$router.replace({
                  path: '/train/index',
                  query: {
                    tabIndex: this.tabIndex,
                    condition: true//判断是否是基础知识点跳课程
                  }
                })
              }
            } else {
              if (result.msg != null && result.msg != '') {
                this.$alert(result.msg);
              }
            }
          },
          (res) => {
            this.$alert(
              "AJAX请求接口异常（/assitantTrain/saveWebLoginAndAssitantDown）！"
            );
          }
        );
    },
    toStudy() {
      console.log(this.CourseLevel, '状态')

      this.$http.post(API_ROOT.college + "/course/getKnowledgeListXlk", { courseId: this.nextcourseId })
        .then(
          (res) => {
            var result = res.data;
            if (result.success) {
              if (result.data.knowledgeRecordFullList.length != 1 && result.data.knowledgeRecordFullList.length != 0) {
                this.$router.replace({ path: '/train/Secondarylist', query: { courseId: this.nextcourseId } })
              } else if (this.CourseLevel == 3) {
                this.$router.replace({
                  path: '/train/SpecialCourses', query: {
                    sceneId: this.$route.query.sceneId,
                    trainId: this.$route.query.trainId,
                    tjkId: this.$route.query.tjkId,
                    assitantTjkId: this.$route.query.tjkId
                  }
                })
              } else if (result.data.knowledgeRecordFullList.length == 1) {
                window.location.href = '/tjkStudy/vedioDetail?courseId=' + this.nextcourseId + '&knowledgeSeq=' + this.nextobject.next.knowledgeSeq + '&CourseLevel=' + this.CourseLevel + '&sceneId=' + this.$route.query.sceneId + '&assitantTjkId=' + this.$route.query.tjkId + '&tjkId=' + this.$route.query.tjkId + '&trainId=' + this.$route.query.trainId + '&knowledgeId=' + this.knowledgeId
              }
            } else {
              if (result.msg != null && result.msg != '') {
                this.$alert(result.msg);
              }
            }
          },
          (res) => {
            this.$alert(
              "AJAX请求接口异常（/assitantTrain/saveWebLoginAndAssitantDown）！"
            );
          }
        );
    },
    //考试页面查看下一个课程
    seecurriculum() {
      var data = {
        'courseId': this.courseId,
      }
      this.$http.post(API_ROOT.college + '/course/getGuideDialog', data).then(response => {
        var result = response.data;
        if (result.success) {
          this.knowledge = result.data.current
          this.fbtBadge = result.data.fbtBadge
          this.nextobject = result.data
          if (this.nextobject.next) { this.knowledgeId = this.nextobject.next.knowledgeId }


          if (this.nextobject.next && !this.nextobject.nextCourse && !this.nextobject.nextCategory) {
            this.knowledgestate = 'jumpToKnowledge'//知识点跳知识点
            this.knowledgeId = this.nextobject.next.knowledgeId
            this.knowledgename = this.nextobject.current.title
          } else if (!this.nextobject.nextCategory && this.nextobject.nextCourse) {

            this.knowledgestate = 'jumpToCourse'//知识点跳课程
            this.knowledgename = this.nextobject.currentCourse.courseName

            if (this.nextobject.nextCourse.courseType == 'Exam' || this.nextobject.nextCourse.assitantType == 'AssitantSpecialRobotExam') {
              this.Coursestate = 'Exam'
            } else if (this.nextobject.nextCourse.courseType == 'Integrate' && this.nextobject.nextCourse.assitantType) {

              this.Coursestate = 'Practice'
            } else if (this.nextobject.nextCourse.courseType == 'Integrate' && !this.nextobject.nextCourse.assitantType) {

              this.Coursestate = 'Study'
            }
          } else if (this.nextobject.nextCategory) {
            this.knowledgestate = 'jumpToCourse'
            this.categoryName = this.nextobject.currentCategory.categoryName
          } else if (!this.nextobject.next && !this.nextobject.nextCourse && !this.nextobject.nextCategory) {
            this.knowledgestate = 'jumpToCourse'
          }

          var ismajorId = localStorage.getItem('majorId')
          this.$http.post(API_ROOT.college + "/courseCategory/queryListXlk", { majorId: ismajorId }).then((res) => {
            var result = res.data;

            if (result.success) {
              let relist = result.data
              if (!this.nextobject.next && !this.nextobject.nextCourse && !this.nextobject.nextCategory) {
                this.knowledgestate = 'jumpToCourse'
                this.categoryName = this.nextobject.currentCategory.categoryName
                this.tabstate = 'noNextTab'
              } else if (this.nextobject.nextCategory) {
                if (this.nextobject.nextCategory == null) {
                } else {

                  this.tabstate = 'hasNextTab'
                  this.nextobject.nextCategory.assitantType
                  relist.forEach((item, index) => {
                    if (item.assitantType == this.nextobject.nextCategory.assitantType) {
                      if (this.nextobject.nextCategory.assitantType == 'OnlineUpgradeSkill') {

                        localStorage.setItem('tabIndex', index)
                        localStorage.setItem('majorId', item.majorId)
                        if (this.nextobject.theoryBadge == false) {
                          this.nextcategoryName = '理论培训'
                        } else {
                          this.nextcategoryName = '实操培训'
                        }
                      } else if (this.nextobject.nextCategory.assitantType == 'VoiceUpgradeSkill') {
                        localStorage.setItem('tabIndex', index)
                        localStorage.setItem('majorId', item.majorId)
                        this.nextcategoryName = '语音技能提升'
                      } else if (this.nextobject.nextCategory.assitantType == 'SysOperate') {
                        this.dazhiJump = true
                        localStorage.setItem('tabIndex', index)
                        localStorage.setItem('majorId', item.majorId)
                        localStorage.setItem('categoryId', item.categoryId)

                      } else {
                        localStorage.setItem('tabIndex', index)
                        localStorage.setItem('majorId', item.majorId)
                        localStorage.setItem('categoryId', item.categoryId)
                        this.categoryName = this.nextobject.currentCategory.categoryName
                        this.nextcategoryName == item.categoryName
                      }
                    }
                  })
                }
              }

            } else {
              if (result.msg != null && result.msg != '') {
                this.$alert(result.msg);
              }
            }
          }, (res) => {
            this.$alert(
              "AJAX请求接口异常（/assitantTrain/saveWebLoginAndAssitantDown）！"
            );
          })
        } else {
          if (result.msg != null && result.msg != '') {
            this.$alert(result.msg);
          }
        }
      }, response => {
        this.$alert('AJAX请求接口异常（/examining/startExam）！');
      })
    },
    replaceNToBr(str) {
      var reg = new RegExp("\n", "g");
      return str.replace(reg, "<br/>");
    },
    getExam() {
      var data = {
        'courseId': this.courseId
      }

      this.$http.post(API_ROOT.college + '/examining/startExam', data).then(response => {
        var result = response.data;
        if (result.success) {
          this.paperQuestion = result.data.groupRecordList;
          this.examRecordId = result.data.examRecordId;
          this.passScore = result.data.passScore;
          if (this.endTime == '') this.endTime = result.data.examRemainingTime;
          this.countdown(this.endTime);
          this.randomNumbers = this.getRandomIntegers(this.endTime, 3);
        } else {
          this.$alert(result.msg);
        }
      }, response => {
        this.$alert('AJAX请求接口异常（/examining/startExam）！');
      })
    },
    countdown(endTime) {
      var self = this;
      self.timer = setInterval(function () {
        endTime--;
        if (endTime >= 0) {
          var sec = parseInt(endTime);
          var min = 0;
          var hour = 0;
          if (sec > 60) {
            min = parseInt(sec / 60);
            sec = parseInt(sec % 60);
            if (min > 60) {
              hour = parseInt(min / 60);
              min = parseInt(min % 60);
            }
          }
          hour = hour < 10 ? "0" + hour : hour;
          min = min < 10 ? "0" + min : min;
          sec = sec < 10 ? "0" + sec : sec;
          if (hour > 0) {
            self.time = `${hour}:${min}:${sec}`;
          } else {
            self.time = `${min}:${sec}`;
          }
          if (endTime == 300) {
            self.open();
          }
        } else {
          clearInterval(self.timer);
          self.time = '时间到';
          self.saveExam();
        }
      }, 1000);
    },
    getRandomIntegers(n, count) {
      const randomNumbers = new Set();
      while (randomNumbers.size < count) {
        const randomNumber = Math.floor(Math.random() * (n - 1)) + 1;
        randomNumbers.add(randomNumber);
      }
      return Array.from(randomNumbers);
    },
    //考试时间提示框
    open() {
      const h = this.$createElement;
      this.$notify({
        title: '',
        message: h('i', { style: 'color: red' }, '离自动交卷还有5分钟，请注意答题时间'),
        duration: 5000
      })
    },
    //保存考试
    saveExam(type) {
      var arry = JSON.parse(JSON.stringify(this.list));

      for (var i = 0; i < arry.length; i++) {
        if (typeof arry[i].tjkAnswerString != 'string') {
          for (var j = 0; j < arry[i].tjkAnswerString.length; j++) {
            var reg = /^[A-Za-z]+$/;
            if (arry[i].tjkAnswerString[j] == null) arry[i].tjkAnswerString[j] = '';
            if (reg.test(arry[i].tjkAnswerString[j])) arry[i].tjkAnswerString[j] = arry[i].tjkAnswerString[j].toUpperCase();
          }
          arry[i].tjkAnswerString = JSON.stringify(arry[i].tjkAnswerString);
        }
      }

      var data = {
        'courseId': this.courseId,
        'examRecordId': this.examRecordId,
        'tjkAnswerString': arry,
        'badgeGetRemark': this.assitantType == 'PreworkOnlineExerciseDirect' ? '老客服路径获得' : null
      }
      this.$http.post(API_ROOT.college + '/examining/submitCourseExam', data).then(response => {
        var result = response.data;
        if (result.success) {
          this.score = result.data.score
          this.times = result.data.remainingExamTimes
          this.state = result.data.examPassState
          this.showExamError = result.data.showExamError
          if (result.data.badge) {
            this.huizhang = result.data.badge.name
          }
          if (this.theory == 'theory') {
            this.completeDialogVisible = true
          } else {
            if (this.state == 'passed') {
              this.seecurriculum()
            }

            this.completeDialogVisible = true
          }
        } else {
          if (result.msg != null && result.msg != '') {
            this.$alert(result.msg);
          }
        }
      }, response => {
        this.$alert('AJAX请求接口异常（/examining/submitCourseExam）！');
      })
    },
    //点击继续测试
    again() {
      this.completeDialogVisible = false
      if (this.trainFlag == 'theory' && this.times == 0) {
        this.$message({ message: '已无剩余测试次数', type: 'warning', center: true, duration: 3000 })
        this.tabIndex = localStorage.getItem('tabIndex')
        this.$router.replace({ path: '/train/index', query: { tabIndex: this.tabIndex } })
        return;
      }
      if (this.trainFlag == 'tjcollege' && this.times == 0) {
        if (this.times == 0) {
          this.$message({ message: '已无剩余测试次数', type: 'warning', center: true, duration: 3000 })
        }
        this.$router.replace({ path: '/train/SpecialCourses', query: { sceneId: this.sceneId, trainId: this.trainId, tjkId: this.tjkId } })
        return;
      }
      window.location.reload();//不方便改为route.push或者window.href,或router.replace
    },
    //点击重新学习
    relearn() {
      if (this.trainFlag == 'theory') {
        this.tabIndex = localStorage.getItem('tabIndex')
        this.$router.replace({ path: '/train/index', query: { tabIndex: this.tabIndex } })
      } else if (this.trainFlag == 'VoiceGraduateExam') {
        this.$router.replace({ path: '/train/SpecialCourses', query: { sceneId: this.sceneId, trainId: this.trainId, tjkId: this.tjkId } })
      } else if (this.trainFlag == 'fbtTrain') {
        this.$router.replace({ path: '/train/index' })
      } else if (this.trainFlag == 'tjcollege') {
        this.$router.replace({ path: '/train/SpecialCourses', query: { sceneId: this.sceneId, trainId: this.trainId, tjkId: this.tjkId } })
      } else {
        this.$router.back()
      }
    },
    goCuotiji() {
      this.$router.replace({
        path: '/train/basicExamDetail/' + this.examRecordId,
        query: {
          courseId: this.courseId,
          trainFlag: this.trainFlag,
          sceneId: this.sceneId,
          trainId: this.trainId,
          tjkId: this.tjkId
        }
      })
    },
    //退出考试
    exitExam() {
      var self = this;
      this.$confirm('确定退出测试？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        //在线理论考核，点返回，直接返回到培训页，其他的返回上个路由页，包括营销培训
        if (this.trainFlag == 'theory') {
          this.tabIndex = localStorage.getItem('tabIndex')
          this.$router.replace({ path: '/train/index', query: { tabIndex: this.tabIndex } })
        }if (this.trainFlag == 'exercise') {
          if(this.sceneId){
            this.$router.replace({ path: '/train/SpecialCourses', query: { sceneId: this.sceneId, assitantType:'OnlineUpgradeSkill',trainFlag:'exercise' } })
          }
          else{
              //----------------这一段临时代码 开始,发版当天(2024-10-18)，可能有客服页面停留在本页面，url拿不到sceneId,所以，改天就不会运行到这里了，日期>2024-10-18就可以删除------------------
              this.$router.back()
              //----------------这一段临时代码 结束------------------
          }

        } else if (this.trainFlag == 'VoiceGraduateExam') {
          this.$router.replace({ path: '/train/SpecialCourses', query: { sceneId: this.sceneId, trainId: this.trainId, tjkId: this.tjkId } })
        } else if (this.trainFlag == 'fbtTrain') {
          localStorage.setItem('tabIndex', this.$route.query.tabIndex);
          this.$router.replace({ path: '/train/index' })
        } else if (this.trainFlag == 'tjcollege') {
          this.$router.replace({ path: '/train/SpecialCourses', query: { sceneId: this.sceneId, trainId: this.trainId, tjkId: this.tjkId } })
        } else {
          this.$router.back()
        }
      });
    },
    //获取大题分类序号
    getNum(key) {
      var arry = ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十', '十一', '十二', '十三', '十四', '十五', '十六', '十七', '十八', '十九', '二十'];
      for (var i = 0; i < arry.length; i++) {
        if (i == key) {
          return arry[i];
          break;
        }
      }
    },
    //判断是否显示已答题样式
    getClass(string) {
      if (typeof string == 'boolean') {
        return true;
      } else if (string instanceof Array) {
        for (var i = 0; i < string.length; i++) {
          if (string[i] != '') {
            return true;
            break;
          }
        }
      } else if (string != '') {
        return true;
      } else {
        return false;
      }
    },
    clickImg(e) {
      this.showImg = true;
      // 获取当前图片地址
      this.imgSrc = e.currentTarget.src;
    },
    viewImg() {
      this.showImg = false;
    }
  }
}
</script>

<style lang="less" scoped>
#train {
  padding: 0 0 0 20px !important;
}

.correct_img {
  width: 60px;
  height: 60px;
  margin: 0 auto;
  margin-bottom: 10px;
}

.score {
  font-size: 36px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #497AF2;
  line-height: 18px;
  text-align: center;
  margin-bottom: 20px;
}

.state_text1 {
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #262626;
  line-height: 18px;
  text-align: center;
  margin-left: 15px;
  margin-bottom: 11px;
}

.state_text2 {
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #262626;
  line-height: 18px;
  text-align: center;
  margin-left: 15px;
}

.state_text2>.spanclass {
  color: #497AF2;
}

/deep/.el-dialog--center {
  border-radius: 10px;
}

.state_text1_1 {
  background: #FFFFFF;
  border-radius: 10px;
  margin-bottom: 11px;
  color: #262626;
  text-align: center;
  font-size: 14px;
}

.failed {
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #262626;
  line-height: 18px;
  margin-left: 15px;
  margin-top: 20px;
  text-align: center;
  margin-bottom: 59px;
}

.failed>span {
  color: #497AF2;
}

.state_text1_2 {
  margin-top: 78px;
}

.badge_box {
  text-align: center;
}

.badge {
  margin-top: 31px;
  margin-bottom: 40px;
  width: 209px;
  display: inline-block;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #262626;
  line-height: 18px;
}

/deep/ .el-dialog--center .el-dialog__body {
  padding: 25px 25px 0px 30px;
}

/deep/ .el-dialog__footer {
  padding: 0px 20px 20px 20px;
}

.button_box {
  display: flex;
  justify-content: center;
}

.button_box1 {
  text-align: center;
}

.out_button_1 {
  width: 100px;
  height: 28px;
  background: #DBE5FF;
  border-radius: 6px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #497AF2;
  line-height: 28px;
  margin-right: 10px;
  cursor: pointer;
}

.out_button_2 {
  width: 100px;
  height: 28px;
  background: #497AF2;
  border-radius: 6px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 28px;
  cursor: pointer;
}

.out_button_3 {
  width: 100px;
  height: 28px;
  background: #497AF2;
  border-radius: 6px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 28px;
  cursor: pointer;
  margin: 0 auto;
}

.newtext {
  margin-bottom: 40px;
  margin-left: 0px !important;
}

.dialog-footer /deep/.el-button {
  background: #497AF2;
  color: #fff;
}
</style>


// WEBPACK FOOTER //
// ./src/page/train/examDetail.vue